import API from "@/api";
import { getField, updateField } from "vuex-map-fields";
import moment from "moment";
import "moment/locale/pt-br";

export const state = () => ({
  usersRequests: [],
  loadingTable: false,
  currentPage: 1,
  pagination: {
    size: 10,
    totalPages: 0,
    totalElements: 0,
    offset: 0,
  },
  // filtros
  selectedGroup: null,
  selectedMunicipio: null,
  selectedRegiaoSaude: null,
  searchText: null,
  selectedStatus: null, // Alterar para novos Status: Aprovado, Rejeitado, Aguaradando Analise

  searchStatus: [],
  statusMap: {},
});

export const getters = {
  getField,
  formatDate: () => (date, includeTimestamp) =>
    formatDate(date, includeTimestamp),
  formatStatus: (state) => (code) => formatStatus(state, code),
};

function objectToMap(status) {
  let map = {};
  status.forEach((elem) => {
    map[elem.code] = elem.label;
  });
  return map;
}

function formatStatus(state, statusCode) {
  if (Object.keys(state.statusMap).length === 0) {
    return statusCode;
  } else {
    return state.statusMap[statusCode];
  }
}

function formatDate(date, includeTimestamp = true) {
  if (!date) return "";
  return moment(date).format(`DD/MM/YYYY ${includeTimestamp ? "HH:mm" : ""}`);
}

function appendFilterParams(state, config) {
  if (state.selectedGroup) {
    config.params.append("idPerfil", state.selectedGroup);
  }

  if (state.selectedRegiaoSaude) {
    config.params.append("nmRegiaoSaude", state.selectedRegiaoSaude);
  }

  if (state.selectedMunicipio) {
    config.params.append("nmMunicipio", state.selectedMunicipio.nmMunicipio);
  }

  if (state.searchText) {
    config.params.append("email", state.searchText);
  }

  if (state.selectedStatus) {
    config.params.append("dsStatus", state.selectedStatus);
  }
}

export const actions = {
  async get({ dispatch, state, commit }) {
    commit("updateField", { path: "auditItems", value: [] });
    commit("updateField", { path: "currentPage", value: 1 });

    const params = new URLSearchParams();
    params.append("page", state.currentPage - 1);
    params.append("size", state.pagination.size);

    const config = {
      params,
    };

    appendFilterParams(state, config);

    commit("updateField", { path: "loadingTable", value: true });

    let result = await API.axios.get(
      "/user-registration-request/api/v1/registration-request",
      config
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.totalElements > 0) {
      commit("updateField", { path: "currentPage", value: 1 });
    } else {
      commit("updateField", { path: "currentPage", value: 0 });
      commit("updateField", { path: "pagination.totalPages", value: 0 });
      commit("updateField", { path: "pagination.offset", value: 0 });
      commit("updateField", {
        path: "pagination.totalElements",
        value: 0,
      });
    }

    // total number of items
    if (result.data.totalElements) {
      commit("updateField", {
        path: "pagination.totalElements",
        value: result.data.totalElements,
      });
      commit("updateField", {
        path: "pagination.totalPages",
        value: result.data.totalPages,
      });
      commit("updateField", {
        path: "pagination.offset",
        value: 0,
      });
    }

    if (result.data.content) {
      const users = result.data.content.map((user) => {
        return {
          ...user,
          name: `${user.firstName ? user.firstName : ""} ${
            user.lastName ? user.lastName : ""
          }`,
        };
      });
      commit("updateField", {
        path: "usersRequests",
        value: users,
      });
    }

    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },

  async getPage({ state, commit }) {
    const params = new URLSearchParams();
    params.append("page", state.currentPage - 1);
    params.append("size", state.pagination.size);

    const config = {
      params: params,
    };

    appendFilterParams(state, config);

    commit("updateField", { path: "loadingTable", value: true });

    const result = await API.axios.get(
      "/user-registration-request/api/v1/registration-request",
      config
    );

    if (!result) {
      commit("updateField", { path: "loadingTable", value: false });
      return undefined;
    } else if (result.status >= 400 && result.status <= 600) {
      commit("updateField", { path: "loadingTable", value: false });
      return result;
    } else if (result.data?.content) {
      const users = result.data.content.map((user) => {
        return {
          ...user,
          name: `${user.firstName ? user.firstName : ""} ${
            user.lastName ? user.lastName : ""
          }`,
        };
      });
      commit("updateField", {
        path: "usersRequests",
        value: users,
      });
      commit("updateField", {
        path: "pagination.offset",
        value: result.data.pageable.offset,
      });
    }
    commit("updateField", { path: "loadingTable", value: false });
    return result;
  },
  async updateUser({ dispatch, state }, payload) {
    const response = await API.axios.put(
      `/user-registration-request/api/v1/registration-request/${payload.idRegistrationRequest}`,
      payload
    );
    return response;
  },

  async getStatus({ dispatch, state, commit, rootState }, payload) {
    if (Object.keys(state.statusMap).length !== 0) return;
    const result = await API.axios.get(
      `/user-registration-request/api/v1/registration-request/status`
    );
    // ifs de status
    if (!result || (result.status >= 400 && result.status < 600)) {
      return !result ? undefined : result;
    } else if (!result.data.empty) {
      commit("updateField", {
        path: "searchStatus",
        value: result.data,
      });
      commit("updateField", {
        path: "statusMap",
        value: objectToMap(result.data),
      });
    }
    return result;
  },
  async downloadFile({ commit }, { id, fileName }) {
    const response = await API.axios.get(
      `/user-registration-request/api/v1/registration-request/${id}/document/${fileName}`,
      {
        responseType: "blob",
      }
    );
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return {
        status: response.status,
        data: { message: "Arquivo baixado com sucesso!" },
      };
    } else {
      return { status: response.status, data: "Erro ao baixar o arquivo!" };
    }
  },
  async viewFile({ commit }, { id, fileName }) {
    const response = await API.axios.get(
      `/user-registration-request/api/v1/registration-request/${id}/document/${fileName}`,
      {
        responseType: "blob",
      }
    );
    if (response.status === 200) {
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
      URL.revokeObjectURL(fileURL);
    } else {
      return response;
    }
  },
};

export const mutations = {
  updateField,
  setItemsPerPage(state, value) {
    state.pagination.size = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
